import { FC, useMemo } from 'react'
import { coordenadorColumns } from './columns/_columns'
import { ColaboradorList } from '../core/_models'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useQueryResponse } from '../core/QueryResponseProvider'
import { useQueryRequest } from '../core/QueryRequestProvider'
import { useListFilters } from '../core/ListFiltersProvider'
import { useCoordenadoresFiltrados } from '../core/useCoordenadoresFiltrados'
import { useT } from '_metronic/i18n/Metronici18n'

export const CoordenadorClienteTable: FC = () => {
  const { responseSemPaginacao: cliente, isLoading, isError, refetch } = useQueryResponse()
  const { filters, hasFilters, clearFilters } = useListFilters()
  const coordenadores = useCoordenadoresFiltrados()
  const { t } = useT()

  const columns = useMemo(() => coordenadorColumns(t), [t])

  const emptyState = hasFilters ? (
    <TableEmptyState
      title={`Nenhum coordenador encontrado para “${filters.busca.trim()}”`}
      description='Revise o termo digitado.'
      action={{ label: 'Limpar filtros', onClick: clearFilters }}
    />
  ) : (
    <TableEmptyState
      title={
        cliente?.nome
          ? `Nenhum coordenador cadastrado em ${cliente.nome}`
          : 'Nenhum coordenador cadastrado'
      }
      description='Use “Adicionar” para cadastrar o primeiro coordenador.'
    />
  )

  return (
    <CustomTable<ColaboradorList>
      id='kt_table_coordenadores_cliente'
      ariaLabel='Coordenadores'
      itemLabel={{ singular: 'coordenador', plural: 'coordenadores' }}
      data={coordenadores}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={emptyState}
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
